import { call, put, takeLatest } from 'redux-saga/effects';
import { createFlashMessage } from '@components/Flash/redux';
import { navigate } from 'gatsby-link';
import {
  registerQuizUser as createRegisterQuizUser,
  updateQuizUserResult as createUpdateQuizUserResult,
  toggleReceiveEmails as createToggleReceiveEmails,
  createNewUserFromQuiz as createCreateNewUserFromQuiz,
  getCep,
  getCityByState,
  crateNewNationalUser
} from '../utils/api/quiz';
import { actionTypes } from './action-types';
import { signInLocal } from './actions';

function* registerQuizUser({ payload }) {
  try {
    const { result, success, message } = yield call(
      createRegisterQuizUser,
      payload
    );

    if (success) {
      yield put({
        type: actionTypes.registerQuizUserComplete,
        payload: result
      });

      if (result.user.id) {
        void navigate('/quiz/result');
      }
    } else {
      yield put(
        createFlashMessage({
          type: 'danger',
          message,
          variables: { dismissible: true }
        })
      );

      yield put({
        type: actionTypes.registerQuizUserComplete,
        payload: null
      });
    }
  } catch (e) {
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.'
      })
    );

    yield put({
      type: actionTypes.registerQuizUserComplete,
      payload: null
    });
  }
}

function* updateQuizUserResult({ payload }) {
  try {
    const { result, success, message } = yield call(
      createUpdateQuizUserResult,
      payload
    );

    if (success) {
      yield put({
        type: actionTypes.updateQuizUserResultComplete,
        payload: result
      });

      yield put(
        createFlashMessage({
          type: 'success',
          message,
          variables: { dismissible: true }
        })
      );

      if (result.id) {
        void navigate('/quiz/result');
      }
    } else {
      yield put(
        createFlashMessage({
          type: 'danger',
          message,
          variables: { dismissible: true }
        })
      );
    }
  } catch (e) {
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
  }
}

function* toggleReceiveEmails({ payload }) {
  try {
    const { result, success, message } = yield call(
      createToggleReceiveEmails,
      payload
    );

    if (success) {
      yield put({
        type: actionTypes.toggleReceiveEmailsComplete,
        payload: result
      });

      yield put(
        createFlashMessage({
          type: 'success',
          message,
          variables: { dismissible: true }
        })
      );

      navigate('/');
    } else {
      yield put(createFlashMessage({ type: 'danger', message, variables: {} }));
    }
  } catch (e) {
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
  }
}

function* createNewUserFromQuiz({ payload }) {
  try {
    const { success, message, result } = yield call(
      createCreateNewUserFromQuiz,
      payload
    );

    if (success) {
      yield put({
        type: actionTypes.createNewUserFromQuizComplete,
        payload: result
      });

      yield put(
        createFlashMessage({
          type: 'success',
          message,
          variables: { dismissible: true }
        })
      );

      yield put(
        signInLocal({
          email: result.email,
          password: payload.password
        })
      );
    } else {
      yield put(
        createFlashMessage({
          type: 'danger',
          message,
          variables: { dismissible: true }
        })
      );

      yield put({
        type: actionTypes.createNewUserFromQuizError
      });
    }
  } catch (error) {
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
    yield put({
      type: actionTypes.createNewUserFromQuizError
    });
  }
}

function* getCepSaga({ payload }) {
  try {
    const { result, success, message } = yield call(getCep, payload);

    if (success) {
      yield put({
        type: actionTypes.getCepComplete,
        payload: result
      });
    } else {
      yield put({
        type: actionTypes.getCepComplete,
        payload: {}
      });
      yield put(
        createFlashMessage({
          type: 'danger',
          message,
          variables: { dismissible: true }
        })
      );
    }
  } catch (error) {
    yield put({
      type: actionTypes.getCepComplete,
      payload: {}
    });
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
  }
}

function* getCityByStateSaga({ payload }) {
  try {
    const { result, success, message } = yield call(getCityByState, payload);

    if (success) {
      yield put({
        type: actionTypes.getCityByStateComplete,
        payload: result
      });
    } else {
      yield put({
        type: actionTypes.getCityByStateComplete,
        payload: {}
      });
      yield put(
        createFlashMessage({
          type: 'danger',
          message,
          variables: { dismissible: true }
        })
      );
    }
  } catch (error) {
    yield put({
      type: actionTypes.getCityByStateComplete,
      payload: {}
    });
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
  }
}

function* createNationalUserSaga({ payload }) {
  try {
    const { result, success, message } = yield call(
      crateNewNationalUser,
      payload
    );

    if (success) {
      yield put({
        type: actionTypes.createNewNationalUserComplete,
        payload: { ...result, successFetchingUser: success }
      });
    } else {
      yield put({
        type: actionTypes.createNewNationalUserError
      });
      yield put(
        createFlashMessage({
          type: 'danger',
          message,
          variables: { dismissible: true }
        })
      );
    }
  } catch (error) {
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
    yield put({
      type: actionTypes.createNewNationalUserError
    });
  }
}

export function createQuizUserSaga(types) {
  return [
    takeLatest(types.registerQuizUser, registerQuizUser),
    takeLatest(types.updateQuizUserResult, updateQuizUserResult),
    takeLatest(types.toggleReceiveEmails, toggleReceiveEmails),
    takeLatest(types.createNewUserFromQuiz, createNewUserFromQuiz),
    takeLatest(types.getCep, getCepSaga),
    takeLatest(types.getCityByState, getCityByStateSaga),
    takeLatest(types.createNewNationalUser, createNationalUserSaga)
  ];
}
